<template>
  <div
    class="support-chat-button"
    @click="openChat"
    v-bind="$attrs"
  >
    <slot>
      <div class="flex items-center gap-3 p-4 rounded-2xl bg-gradient-to-r from-orange-500 to-orange-600 text-white shadow-lg cursor-pointer hover:shadow-xl transition-shadow duration-300">
        <div class="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-5 h-5"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
          </svg>
        </div>
        <div class="flex-1">
          <p class="font-semibold">Aide & Support</p>
          <p class="text-sm text-white/80">Besoin d'assistance ?</p>
        </div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-5 h-5"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polyline points="9 18 15 12 9 6" />
        </svg>
      </div>
    </slot>
  </div>
</template>

<script setup>
import { bus } from '@core/events/eventSystem';
import constants from '@core/utils/constants';

function openChat() {
  bus.emit(constants.EVENTS.CHAT.OPEN_WITH_ADMIN);
}
</script>

<style scoped>
.support-chat-button {
  user-select: none;
}
</style>
